export const mockArticles = {
  "mock-base-1": {
    id: "mock-base-1",
    name: "博努力评价基地简介",
    release_time: "2026-01-15",
    brief: "博努力（北京）仿真技术有限公司评价基地概况介绍",
    category_name: "基地基础",
    content: `
      <p>博努力（北京）仿真技术有限公司作为教育部批准的1+X证书制度试点培训评价组织，依托公司在电力仿真领域二十余年的技术积累与行业资源，建设专业化、标准化的技能评价基地，为院校及社会学习者提供权威、公正、高效的技能评价服务。</p>
      <p>评价基地位于北京市，配备先进的仿真考核设备与标准化考场，涵盖垃圾焚烧发电、火力发电、风力发电等多个专业方向，可同时满足数百名考生的实操考核需求。</p>
      <p>基地秉承"产教融合、工学结合"的理念，与全国200余所职业院校建立合作关系，累计完成技能评价10万余人次，为行业输送了大量高素质技术技能人才。</p>
      <p><strong>基地主要职能：</strong></p>
      <p>1. 组织开展1+X职业技能等级证书考核评价工作；</p>
      <p>2. 承担考评员、督导员培训与认证；</p>
      <p>3. 提供仿真教学资源与实训设备支持；</p>
      <p>4. 开展产教融合、协同育人等合作交流。</p>
    `,
  },
  "mock-train-1": {
    id: "mock-train-1",
    name: "培训资源概览",
    release_time: "2026-02-20",
    brief: "评价基地培训资源与教学支持体系介绍",
    category_name: "培训资源",
    content: `
      <p>博努力评价基地整合公司核心仿真产品与技术资源，为合作院校及培训单位提供全方位的培训支持，助力1+X证书制度试点工作顺利推进。</p>
      <p><strong>一、仿真教学软件</strong></p>
      <p>提供垃圾焚烧发电、600MW/660MW/1000MW火力发电、330MW机组、50MW母管制机组等多套仿真系统，覆盖锅炉、汽轮机、电气等主要专业模块，支持单人/多人协同实训模式。</p>
      <p><strong>二、师资培训课程</strong></p>
      <p>定期举办考评员培训、督导员培训及专业师资研修班，由行业专家与资深工程师授课，帮助院校教师掌握证书标准与考核要点。</p>
      <p><strong>三、配套教学资料</strong></p>
      <p>提供与证书标准对应的课件、实训指导书、考核样题及操作视频，支持院校开展理实一体化教学。</p>
      <p><strong>四、远程培训支持</strong></p>
      <p>通过线上平台提供录播课程与直播答疑，方便偏远地区院校师生参与培训，降低培训成本。</p>
    `,
  },
  "mock-cert-1": {
    id: "mock-cert-1",
    name: "证书介绍及报考指南",
    release_time: "2026-03-10",
    brief: "1+X职业技能等级证书介绍与报考流程说明",
    category_name: "证书介绍及报考",
    content: `
      <p>1+X证书制度是国务院印发的《国家职业教育改革实施方案》中提出的重要改革举措，旨在鼓励学生在获得学历证书的同时，积极取得各类职业技能等级证书，拓展就业创业本领，缓解结构性就业矛盾。</p>
      <p><strong>一、证书体系</strong></p>
      <p>博努力作为培训评价组织，目前开展垃圾焚烧处理、发电集控运行等专业的职业技能等级证书（初、中、高级）评价工作。证书由培训评价组织颁发，经教育部认可，全国通用。</p>
      <p><strong>二、报考条件</strong></p>
      <p>初级：中职、高职及以上院校相关专业在校学生，或社会从业人员；</p>
      <p>中级：取得初级证书后，或具备一定从业经验的相关专业学生及从业人员；</p>
      <p>高级：取得中级证书后，或具备丰富实践经验的相关从业人员。</p>
      <p><strong>三、报考流程</strong></p>
      <p>1. 院校统一组织报名，填写考生信息并提交至评价基地；</p>
      <p>2. 评价基地审核报名信息，安排考核批次；</p>
      <p>3. 考生参加理论考试与实操考核；</p>
      <p>4. 考核合格者，由培训评价组织颁发相应等级证书。</p>
      <p><strong>四、咨询联系</strong></p>
      <p>如有报考疑问，请联系博努力评价基地：电话 010-XXXXXXXX，邮箱 certificate@bernouly.com。</p>
    `,
  },
  "mock-std-1": {
    id: "mock-std-1",
    name: "垃圾焚烧处理职业技能等级证书标准（初级）",
    release_time: "2025-12-01",
    brief: "初级证书评价标准及考核要求说明",
    category_name: "评价标准",
    content: "<p>垃圾焚烧处理职业技能等级证书（初级）评价标准全文内容...</p>",
  },
  "mock-std-2": {
    id: "mock-std-2",
    name: "垃圾焚烧处理职业技能等级证书标准（中级）",
    release_time: "2025-11-20",
    brief: "中级证书评价标准及考核要求说明",
    category_name: "评价标准",
    content: "<p>垃圾焚烧处理职业技能等级证书（中级）评价标准全文内容...</p>",
  },
  "mock-std-3": {
    id: "mock-std-3",
    name: "发电集控运行职业技能等级证书标准（初级）",
    release_time: "2025-10-15",
    brief: "发电集控运行初级证书评价标准",
    category_name: "评价标准",
    content: "<p>发电集控运行职业技能等级证书（初级）评价标准全文内容...</p>",
  },
  "mock-std-4": {
    id: "mock-std-4",
    name: "发电集控运行职业技能等级证书标准（中级）",
    release_time: "2025-09-28",
    brief: "发电集控运行中级证书评价标准",
    category_name: "评价标准",
    content: "<p>发电集控运行职业技能等级证书（中级）评价标准全文内容...</p>",
  },
  "mock-sys-1": {
    id: "mock-sys-1",
    name: "评价基地管理制度（2026版）",
    release_time: "2026-01-01",
    brief: "评价基地日常运行与管理规章制度",
    category_name: "评价制度",
    content: "<p>评价基地管理制度（2026版）全文内容...</p>",
  },
  "mock-sys-2": {
    id: "mock-sys-2",
    name: "考评员管理办法",
    release_time: "2025-12-15",
    brief: "考评员资格认定、培训与考核管理办法",
    category_name: "评价制度",
    content: "<p>考评员管理办法全文内容...</p>",
  },
  "mock-sys-3": {
    id: "mock-sys-3",
    name: "考核组织实施规范",
    release_time: "2025-11-10",
    brief: "技能等级考核组织实施流程与规范要求",
    category_name: "评价制度",
    content: "<p>考核组织实施规范全文内容...</p>",
  },
  "mock-sys-4": {
    id: "mock-sys-4",
    name: "证书颁发与档案管理细则",
    release_time: "2025-10-20",
    brief: "证书颁发流程及考生档案管理细则",
    category_name: "评价制度",
    content: "<p>证书颁发与档案管理细则全文内容...</p>",
  },
};

export function formatArticleDate(releaseTime) {
  const date = new Date(releaseTime);
  return {
    Y: date.getFullYear(),
    M: date.getMonth() + 1,
    D: date.getDate(),
  };
}

export function getMockArticleList(ids) {
  return ids.map((id) => {
    const article = mockArticles[id];
    return {
      ...article,
      tm: formatArticleDate(article.release_time),
      content: article.content,
      category_id: id,
    };
  });
}
